{
  "agent_name": "{{brand}} 管理プログラム",
  "crumbs": "現在の位置",
  "common": {
    "cancel": "キャンセル",
    "details": "詳細",
    "loading": "読み込み中",
    "retry": "再試行",
    "saving": "保存中…"
  },
  "nav": {
    "group": "IT 監視",
    "incidents": "インシデント",
    "unhandled_n": "まだ誰も対応していないインシデント {{n}} 件",
    "hosts": "ホスト",
    "network": "ネットワークとアプリ",
    "remote": "リモート支援"
  },
  "sev": {
    "P1": "緊急",
    "P2": "重要",
    "P3": "通常"
  },
  "home": {
    "bad": "異常",
    "attention": "注意",
    "ok": "正常",
    "unreadable": "取得不可",
    "unset": "未設定",
    "maintenance": "メンテナンス中",
    "maintenance_until": "メンテナンス中 · {{time}} まで",
    "off_hours": "営業時間外",
    "baselining": "基準値を作成中（状態には影響しません）"
  },
  "now": {
    "ongoing_for": "発生中 · {{n}} 分",
    "recovered_at": "{{time}} に復旧"
  },
  "handling": {
    "open": "未対応",
    "open_recovered": "未対応（まだ誰も見ていません）",
    "acknowledged_by": "{{name}}が確認済み",
    "claimed_by": "{{name}}が対応中",
    "mine": "あなたが対応中",
    "since": " · {{time}} から",
    "resolved": "クローズ済み"
  },
  "person": {
    "you": "あなた",
    "someone": "誰か",
    "system": "システム"
  },
  "impact": {
    "not_recording": "{{n}} 台のカメラが録画していません · {{min}} 分",
    "gap": "録画欠落 {{n}} 台 × {{min}} 分（復元できません）",
    "fine": "録画への影響なし",
    "fine_note": "録画への影響なし：{{note}}",
    "unknown": "録画状態を取得できません",
    "unknown_note": "録画状態を取得できません：{{note}}"
  },
  "incident": {
    "affected_n": "影響 {{n}} 台",
    "recurring": "繰り返し発生 · {{n}} 回",
    "for_min": "{{n}} 分経過",
    "silenced_until": "{{time}} まで通知停止 · {{name}}",
    "alarms_open": "同じ$t(translation:leaf.cur)のアラーム {{n}}",
    "impact": "影響",
    "see_gap": "欠落の前後を見る",
    "alarm_xref": "同じ$t(translation:leaf.cur)に未対応のアラームが {{n}} 件あります",
    "see_alarms": "アラームを見る",
    "affected_title": "影響を受けたデバイス（{{n}}）",
    "affected_all": "全 {{n}} 台",
    "col_kind": "種類",
    "col_name": "名前",
    "col_state": "状態",
    "timeline": "タイムライン",
    "people": "このインシデントの関係者",
    "handler": "対応者",
    "seen_by": "確認した人",
    "resolved_by": "クローズ",
    "escalation": "エスカレーション",
    "nobody": "まだいません",
    "not_found": "このインシデントは見つかりません",
    "not_found_body": "保存期間（13 か月）を過ぎたか、この$t(translation:leaf.cur)へのアクセス権がなくなった可能性があります。",
    "not_found_crumb": "見つかりません",
    "back_list": "インシデント一覧に戻る",
    "unavailable": "このインシデントを読み込めません",
    "abar": "インシデントの操作",
    "notified": "通知済み"
  },
  "target": {
    "camera": "カメラ",
    "recorder": "レコーダー",
    "host": "ホスト",
    "network_device": "ネットワーク機器",
    "probe": "アプリケーションプローブ",
    "kinio_device": "デバイス"
  },
  "target_state": {
    "not_recording": "録画なし",
    "offline": "オフライン",
    "unreadable": "取得不可",
    "recovered": "復旧",
    "ok": "正常",
    "service_stopped": "サービス停止",
    "on_battery": "バッテリー運転中"
  },
  "ev": {
    "system": "システム",
    "bad": "異常",
    "person": "人の操作",
    "recover": "復旧",
    "notify": "通知"
  },
  "ev_person": {
    "open": "{{name}}：再オープン",
    "acknowledged": "{{name}}：確認済み",
    "claimed": "{{name}}：対応開始",
    "resolved": "{{name}}：クローズ",
    "assigned": "{{name}}：{{to}} に引き継ぎ"
  },
  "act": {
    "claim": "対応する",
    "take_over": "代わりに対応する",
    "acknowledge": "確認済みにする",
    "resolve": "解決済みにする…",
    "close": "クローズ…"
  },
  "resolve": {
    "title": "このインシデントをクローズ",
    "body": "クローズ後はエスカレーションとリマインドを停止します。30 分以内に同じ原因で再発した場合は、このインシデントに戻ります。",
    "note": "対応内容（任意）",
    "ok": "クローズ"
  },
  "conflict": {
    "handled_by": "{{name}} がすでに対応しています。画面を更新しました",
    "changed": "このインシデントは他の人が変更しました。画面を更新しました",
    "next": "あなたの操作は送信されていません。引き継ぐには〔代わりに対応する〕を押してください。"
  },
  "filter": {
    "all": "すべて",
    "unclaimed": "未担当",
    "mine": "自分が対応中",
    "org": "組織",
    "org_label": "組織：{{label}}",
    "org_all": "すべての組織",
    "org_n": "{{n}} 組織",
    "org_unnamed": "顧客組織",
    "org_clear": "組織の絞り込みを解除",
    "org_max": "組織は最大 {{n}} 件まで選べます"
  },
  "overview": {
    "it_blocks": "IT 監視",
    "incidents_title": "いま対応が必要なインシデント",
    "sev_n_P1": "緊急 {{n}}",
    "sev_n_P2": "重要 {{n}}",
    "sev_n_P3": "通常 {{n}}",
    "filter": "インシデントの絞り込み",
    "see_all": "全 {{n}} 件を見る",
    "none_watching": "いま対応が必要なことはありません · {{homes}} か所の$t(translation:leaf.cur)を監視中",
    "none_filtered": "該当するインシデントはありません",
    "incidents_unavailable": "インシデント一覧を読み込めません。ほかの欄は通常どおりです。",
    "homes_title": "$t(translation:leaf.cur)の状態",
    "homes_n": "{{n}} か所の$t(translation:leaf.cur)",
    "homes_counts": "状態別の$t(translation:leaf.cur)数",
    "homes_unavailable": "$t(translation:leaf.cur)の状態を読み込めません。ほかの欄は通常どおりです。",
    "others_ok": "ほか {{n}} か所は正常",
    "homes_more": "ほかに {{n}} か所。インシデント一覧ですべて表示",
    "none_watching_hosts": "いま対応が必要なことはありません · {{homes}} か所の$t(translation:leaf.cur)、{{hosts}} 台のパソコンを監視中",
    "orgs_homes_n": "{{orgs}} 組織 · {{n}} か所の$t(translation:leaf.cur)",
    "org_p1_unclaimed": "未担当の緊急 {{n}}",
    "org_bad_homes": "異常 {{n}} か所の$t(translation:leaf.cur)",
    "org_unreadable_homes": "取得不可 {{n}} か所の$t(translation:leaf.cur)",
    "org_open": "未解決のインシデント {{n}}",
    "org_hosts_offline": "オフラインのホスト {{n}}",
    "orgs_others_ok": "ほか {{n}} 組織は正常",
    "orgs_more": "ほかに {{n}} 組織。インシデント一覧ですべて表示"
  },
  "live": {
    "on_s": "リアルタイム · {{n}} 秒前に更新",
    "on_m": "リアルタイム · {{n}} 分前に更新",
    "off": "中断 · 最終更新 {{time}}",
    "stale_bar": "更新が {{n}} 分止まっています：{{time}} 時点の状態です。新しいインシデントがあるかもしれません。",
    "reconnect": "再接続"
  },
  "incidents": {
    "tabs": "インシデントのタブ",
    "tab_open": "未クローズ",
    "tab_open_n": "未クローズ（{{n}}）",
    "tab_all": "すべて",
    "none_open": "未クローズのインシデントはありません",
    "none": "インシデントはまだありません",
    "none_filtered": "該当するインシデントはありません",
    "clear_filter": "絞り込みを解除",
    "see_all": "すべてのインシデントを見る",
    "load_more": "さらに読み込む",
    "shown_all": "全 {{n}} 件を表示中",
    "unavailable": "インシデント一覧を読み込めません"
  },
  "enable_card": {
    "title": "{{console}} で {{org}} のネットワークとパソコンを見守る",
    "body": "スイッチの切断、サーバーの停止、ディスクの故障の兆候があると、どの$t(translation:leaf.cur)か、録画に影響があるか、考えられる原因と対処を先にお知らせします。対応が必要なことだけを表示し、鳴り続けることはありません。",
    "note": "パソコンに「{{agent}}」をインストールする必要があります。ヘルス情報だけを報告し、画面・ファイル・入力は見ません。有効にするには {{org}} の責任者がデータ処理契約に同意する必要があります。",
    "start": "始める",
    "later": "あとで"
  },
  "org": {
    "title": "IT 監視",
    "crumb_org": "組織設定",
    "enable_title": "IT 監視を有効にする",
    "enable_crumb": "有効化",
    "tabs": "IT 監視のタブ",
    "tab_status": "有効化",
    "tab_oncall": "当番表",
    "tab_keys": "管理者パスキー",
    "no_admin": "IT 監視を設定できるのは組織のオーナーか組織管理者だけです。",
    "dpa": "データ処理契約",
    "dpa_accepted": "{{v}} 版に同意済み（{{time}}）",
    "dpa_none": "未同意",
    "homes": "監視中の$t(translation:leaf.cur)",
    "homes_none": "まだありません",
    "home_settings": "監視設定",
    "start_wizard": "有効化を始める",
    "open_wizard": "$t(translation:leaf.cur)の追加・展開トークンの作成",
    "manage": "設定",
    "card_enabled": "{{n}} か所の$t(translation:leaf.cur)を監視中 · 当番表と有効化はここで設定",
    "card_none": "まだ有効になっていません。$t(translation:leaf.cur)のネットワークとパソコンを見守れます。",
    "tab_templates": "監視テンプレート",
    "tab_handover": "引き継ぎ",
    "tab_built": "代行作成した顧客"
  },
  "keys": {
    "intro": "各パソコンの管理プログラムは、このリストにある署名用パスキーで署名されたセキュリティポリシーだけを受け付けます。追加にはリスト上の 1 つで署名ページでの確認が必要です。削除に署名は不要ですが、組織が以前に作成した展開トークンはすべて無効になります。",
    "unavailable": "管理者リストを読み込めません（{{detail}}）。",
    "current": "現在のリスト（第 {{v}} 版）",
    "empty": "リストは空です。まだ誰もセキュリティポリシーに署名できません。最初の 1 つは署名不要です。以後に作成した展開トークンにだけ新しいリストが含まれます。",
    "you": "あなた",
    "stale": "アカウントまたはパスキーが存在しません。削除してください",
    "remove_replaced": "削除（スマホやパソコンを交換した）",
    "remove_lost": "削除（紛失・盗難）",
    "confirm_title": "{{who}} のパスキー {{id}} を削除",
    "confirm_tokens": "削除すると、組織が以前に作成した展開トークン {{n}} 個が無効になります（チェックイン済みのパソコンには影響しません）：",
    "confirm_no_tokens": "無効になる展開トークンはありません。",
    "token_line": "{{name}} · 未チェックイン {{n}} 台",
    "confirm_remove": "今すぐ削除（トークン {{n}} 個が無効）",
    "candidates": "追加できる署名用パスキー",
    "no_candidates": "ありません。オーナーまたは管理者がセットアップウィザード ⓪ で署名用パスキーを作成すると表示されます。",
    "add_anchor": "追加",
    "add_sign": "追加（自分のパスキーで署名）",
    "need_listed": "リストに載っている管理者に追加してもらう必要があります。あなたの署名用パスキーはまだリストにありません。",
    "reinstall_title": "{{n}} 台のパソコンで管理者リストを更新できません",
    "reinstall_body": "リストが一度空になってから再設定されたため、これらのパソコンはセキュリティ規則により新しいリストを受け付けません。リモート支援と署名が必要な自動対処は拒否されます。新しい展開トークンで管理プログラムを再インストールしてください（新しいトークンは現在のリストを含みます）。再インストール後は古い登録情報が置き換わります。",
    "reinstall_reanchor": "パソコンのリストは v{{v}}、その後に再設定あり",
    "reinstall_rejected": "パソコンが新しいリストを拒否（{{code}}）",
    "reinstall_token": "新しい展開トークンを作成",
    "reinstall_token_home": "新しい展開トークンを作成 · {{home}}"
  },
  "wizard": {
    "steps": "有効化の手順",
    "done_sr": "（完了）",
    "step_0": "パスキー",
    "step_1": "データ処理契約",
    "step_2": "$t(translation:leaf.cur)を選ぶ",
    "step_5": "展開トークン",
    "title_0": "パスキーがあるか確認",
    "title_1": "IT 監視データ処理契約",
    "title_2": "監視する$t(translation:leaf.cur)を選ぶ",
    "title_5": "展開トークンを作成",
    "next_0": "次へ：データ処理契約",
    "next_1": "次へ：$t(translation:leaf.cur)を選ぶ",
    "next_5": "完了",
    "prev": "戻る",
    "skip": "この手順をスキップ",
    "save_leave": "保存して終了",
    "skip_finish": "スキップしてあとで作成",
    "finish": "完了して IT 監視に戻る",
    "progress": "設定の進捗 {{n}} / {{total}}",
    "progress_note": "どの手順もスキップでき、あとで「組織設定 › IT 監視」から続けられます。",
    "denied": "有効にできるのは組織のオーナーか組織管理者だけです",
    "denied_body": "{{org}} のオーナーか組織管理者に有効化を依頼してください。",
    "status_unavailable": "IT 監視の状態を読み込めません（{{detail}}）。",
    "passkey_ok": "署名用パスキーを {{n}} 個お持ちです。",
    "passkey_need": "パソコンの管理者リストの変更やセキュリティポリシーの署名には署名用パスキーが必要です（専用の署名ページで作成し、ログイン用パスキーとは別です。認証コードは使えません）。",
    "passkey_readonly": "パスキーを登録するまで、IT 監視のセキュリティ設定は読み取り専用です。",
    "passkey_add": "署名用パスキーを作成",
    "passkey_no_sign": "この環境ではまだ署名ページが使えないため、署名用パスキーを作成できません。",
    "passkey_sign_note": "新しいウィンドウ（署名ページ）が開くので、そこで確認してください。",
    "passkey_name": "IT 監視",
    "passkey_unsupported": "このブラウザはパスキーに対応していません。別のブラウザかスマートフォンで登録してください。",
    "passkey_err": "登録できませんでした（{{code}}）。",
    "dpa_version": "バージョン {{v}}",
    "dpa_summary": "概要",
    "dpa_s1": "{{org}} がデータの管理者、サービス提供者が受託者です。",
    "dpa_s2": "パソコンとネットワーク機器のヘルス情報（CPU、メモリ、ディスク、サービスの稼働、通信量の合計）を集めます。画面、ファイル内容、キー入力の内容は集めません。",
    "dpa_s3": "保存期間：指標 24 か月（集計）、インシデント 13 か月、監査ログ 1 年以上。終了後 30 日で削除。",
    "dpa_full": "全文を見る",
    "dpa_accept": "{{org}} を代表して IT 監視データ処理契約（{{v}} 版）に同意します",
    "dpa_accepted": "{{v}} 版に同意済み（{{time}}）。",
    "dpa_updated": "契約が {{v}} 版に更新されました。もう一度確認してから同意してください。",
    "before_dpa": "同意前にできること",
    "before_dpa_body": "$t(translation:leaf.cur)の選択、展開トークンの作成、パソコンへの「{{agent}}」の導入は先にできます。パソコンは同意後に報告を始め、再インストールは不要です。",
    "need_dpa": "$t(translation:leaf.cur)を有効にするには、先にデータ処理契約への同意が必要です。",
    "to_dpa": "契約に同意する",
    "homes_intro": "選んだ$t(translation:leaf.cur)の監視を始めます。IT 監視を有効にした$t(translation:leaf.cur)では、デバイスの切断や録画の中断はインシデントとして通知します（同じことは 1 回だけ通知）。",
    "homes_none": "この組織にはまだ$t(translation:leaf.cur)がありません。",
    "home_enabled": "有効",
    "enable": "{{n}} か所の$t(translation:leaf.cur)を有効にする",
    "need_homes": "展開トークンを作るには、先に$t(translation:leaf.cur)を 1 つ以上有効にしてください。",
    "to_homes": "$t(translation:leaf.cur)を選ぶ",
    "token_side": "トークンの作成時にもう一度本人確認をします。トークンは一度だけ表示されます。"
  },
  "token": {
    "name": "名前",
    "home": "チェックイン先の$t(translation:leaf.cur)",
    "default_name": "{{home}} 第 1 陣",
    "expiry": "有効期間",
    "days": "{{n}} 日（{{until}} まで）",
    "expiry_hint": "最長 30 日。期限後にまだ導入していないパソコンには新しいトークンが必要です。",
    "max": "最大台数（必須）",
    "max_hint": "ライセンス台数を超えたパソコンは最初は未ライセンスで、購入後にチェックイン順にライセンスされます。",
    "max_bad": "1 から 10000 の整数を入力してください。",
    "cidrs": "チェックインを許可するネットワーク（任意）",
    "cidrs_hint": "ほかのネットワークで導入したパソコンは拒否され、社内ネットワークに戻ると自動で再試行します。",
    "cidrs_bad": "ネットワーク範囲ではありません：{{list}}",
    "ownership": "これらのパソコンの所有区分",
    "own_org": "組織の所有",
    "own_byod": "従業員の私物（BYOD）",
    "ownership_hint": "あとでホストのページで 1 台ずつ変更できます。",
    "expected": "予定リスト（任意）",
    "expected_hint": "CSV または AD からエクスポートしたパソコン名を取り込むと、チェックイン状況にまだチェックインしていないパソコンが表示されます。",
    "expected_n": "{{n}} 台のパソコン名を読み込みました。",
    "once_note": "作成前にもう一度本人確認をします。トークンは一度だけ表示されます。",
    "create": "本人確認して作成",
    "new": "展開トークンを作成…",
    "new_title": "展開トークンを作成",
    "once_title": "表示されるのはこの一度だけです",
    "once_body": "このページを離れると二度と表示されません。インストール設定にコピーするか、ファイルとしてダウンロードしてください。",
    "copy": "トークンをコピー",
    "copied": "コピーしました",
    "download": "トークンファイルをダウンロード",
    "once_meta": "{{name}} · {{home}} · 最大 {{n}} 台 · {{until}} まで",
    "install_title": "「{{agent}}」を導入する",
    "install_1": "見守るパソコンに「{{agent}}」を導入します。",
    "install_2": "トークンファイルをそのパソコンに置き（システム管理者だけが読めるようにして）、インストール時にこのファイルを指定します。トークンをコマンドラインに書かないでください。",
    "install_3": "導入後、「{{agent}}」は自動でチェックインします。そのパソコンで「{{agent}}」を開くと、集めている内容を確認できます。",
    "install_note": "誰でも読める共有フォルダーにトークンを置かないでください。見える人全員にトークンを渡すのと同じです。",
    "after_title": "導入したら",
    "after_body": "チェックイン状況で各パソコンの状態と失敗の理由をリアルタイムで確認できます。",
    "see_progress": "チェックイン状況を見る",
    "state_active": "有効",
    "state_expired": "期限切れ",
    "state_exhausted": "上限到達",
    "state_revoked": "無効",
    "col_state": "状態",
    "col_progress": "チェックイン",
    "col_expires": "期限",
    "progress_short": "チェックイン {{a}} / {{n}} · 失敗 {{f}}",
    "list_unavailable": "展開トークンを読み込めません",
    "none": "展開トークンはまだありません",
    "none_body": "トークンを作ってインストール時に使うと、パソコンがこの$t(translation:leaf.cur)にチェックインします。",
    "unavailable": "このトークンを読み込めません",
    "revoke_btn": "取り消す…",
    "revoke_title": "「{{name}}」を取り消す",
    "revoke_body": "まだチェックインしていない {{n}} 台はチェックインに失敗します。チェックイン済みのパソコンには影響しません。",
    "revoke": "トークンを取り消す",
    "revoked_manual": "このトークンは取り消されました（{{time}}）。未チェックインのパソコンには新しいトークンが必要です。",
    "revoked_admin_removed": "このトークンは無効になりました（{{time}}）：管理者リストから誰かが削除されました。新しいトークンを作り、インストール設定の古いトークンと置き換えてください。",
    "revoked_creator_left": "このトークンは無効になりました（{{time}}）：作成者が組織を離れました。新しいトークンを作り、インストール設定の古いトークンと置き換えてください。",
    "revoked_rebuilt": "このトークンは新しいものに置き換えられました（{{time}}）。",
    "expired_bar": "このトークンは {{time}} に期限切れになりました。未導入のパソコンには新しいトークンが必要です。",
    "kpi_approved": "チェックイン済み",
    "kpi_failed": "失敗",
    "kpi_remaining": "未チェックイン",
    "kpi_remaining_note": "チェックインを送れなかったパソコンはクラウドから見えません",
    "failed_title": "失敗（{{n}}）",
    "col_host": "パソコン",
    "col_reason": "理由とできること",
    "col_os": "OS",
    "col_ip": "送信元 IP",
    "col_time": "時刻",
    "failed": "失敗",
    "notyet_title": "未チェックイン（{{n}}）",
    "notyet_expected": "予定リストのうち未チェックイン：{{list}}{{more}}",
    "and_more": " ほか {{n}} 台",
    "notyet_hint": "1 時間以上応答がないパソコンは導入に失敗している可能性があります（インストール設定が未適用、電源オフ、ウイルス対策ソフトによるブロック）。理由はそのパソコンでのみ確認できます。",
    "ok_title": "チェックイン済み（{{n}}）",
    "ok_none": "まだチェックインしたパソコンはありません。",
    "unexpected": "予定リストにない",
    "kpi_pending": "確認待ち",
    "rebuild_btn": "再作成…",
    "rebuild_title": "「{{name}}」を再作成",
    "rebuild": "本人確認して再作成",
    "rebuild_body": "元の$t(translation:leaf.cur)、送信元ネットワーク、所有区分、予定リストを引き継ぎ、現在の管理者リストに紐付けます。上限台数はまだチェックインしていない {{n}} 台です。新しいトークンは一度だけ表示されます。インストール設定（GPO スクリプト、Intune、RMM）の古いトークンを置き換えてください。置き換えるまで、未チェックインのパソコンは古いトークンで再試行して失敗し続けるため、インシデント台数が増えるのは正常です。チェックイン済みのパソコンには影響しません。",
    "rebuilt_note": "再作成した新しいトークンです。古いトークンは置き換えられました。下のインストールパラメーターを GPO スクリプト、Intune、RMM に設定してください。"
  },
  "enroll": {
    "todo_prefix": "できること：",
    "reason_expired": "トークンの期限切れ",
    "todo_expired": "新しいトークンを作り、インストール設定の古いトークンと置き換えてください。",
    "reason_exhausted": "台数の上限に達しました",
    "todo_exhausted": "新しいトークンを作るか、管理者に上限の引き上げを依頼してください。",
    "reason_revoked": "トークンが無効です",
    "todo_revoked": "作成者か管理を委託された設置業者に新しいトークンを作ってもらい、インストール設定の古いトークンと置き換えてください。",
    "reason_source": "送信元ネットワークが許可範囲外です",
    "todo_source": "社内ネットワークに戻ると自動で再試行します。またはトークンに許可するネットワーク範囲を追加してください。",
    "reason_dpa": "データ処理契約にまだ同意していません",
    "todo_dpa": "同意後、パソコンは 15 分ごとに自動で再試行します。再インストールは不要です。",
    "reason_clock": "パソコンの時刻が大きくずれています",
    "todo_clock": "このパソコンの時刻を合わせると自動で再試行します。",
    "reason_hw": "このパソコンのハードウェア識別が一致しません",
    "todo_hw": "複製したシステムイメージの可能性があります。そのパソコンで再インストールしてください。",
    "reason_invalid": "トークンが正しくありません",
    "todo_invalid": "インストール設定のトークンが欠けていないか確認してください。",
    "reason_other": "チェックインに失敗しました",
    "todo_other": "詳細のエラーコードを確認するか、そのパソコンで管理プログラムを開いて理由を確認してください。",
    "reason_host_rejected": "追加を拒否済み",
    "todo_host_rejected": "このパソコンは今後このトークンではチェックインできません。追加する場合はトークンを再作成し、新しいトークンで再インストールしてください。"
  },
  "home_settings": {
    "title": "監視設定",
    "crumb_sites": "組織と拠点",
    "tabs": "監視設定のタブ",
    "tab_tokens": "展開トークン",
    "tab_notify": "通知",
    "tokens_intro": "展開トークンを使ってインストールしたパソコンは、この$t(translation:leaf.cur)にチェックインします。",
    "not_found": "$t(translation:leaf.cur)が見つかりません",
    "back_sites": "組織と拠点に戻る",
    "not_enabled": "この$t(translation:leaf.cur)はまだ IT 監視が有効ではありません。トークンは先に作れます。パソコンは有効化後に報告を始めます。",
    "no_org": "この$t(translation:leaf.cur)は組織に属していないため、当番表はありません。",
    "unavailable": "監視設定を読み込めません",
    "tab_collectors": "コレクター",
    "tab_thresholds": "しきい値と重要度",
    "tab_probes": "プローブ",
    "tab_windows": "メンテナンスと営業時間",
    "tab_site": "現場情報"
  },
  "notify": {
    "schedule": "当番表",
    "no_schedule": "当番表を使わない",
    "no_schedule_hint": "当番表がない場合、緊急インシデントは$t(translation:leaf.cur)のオーナーと管理者に送られます。",
    "schedule_hint": "緊急インシデントは 0 分でその時間帯の当番に送られます。当番がいない時間帯は当番責任者に直接送られます。",
    "contact": "顧客の連絡先",
    "contact_default": "既定：組織のオーナー {{name}}",
    "contact_default_none": "既定：組織のオーナー",
    "contact_hint": "当番と当番責任者のどちらにも届かないとき、緊急インシデントはこの人に送られます。",
    "channels": "通知方法：アプリのプッシュ通知（緊急インシデントは即時通知）とメール。SMS と音声通話はありません。",
    "save_note": "通知設定の変更にはもう一度本人確認が必要で、この$t(translation:leaf.cur)の組織のオーナーと管理者に通知されます。",
    "save": "保存",
    "saved": "保存しました。",
    "edit_schedules": "当番表を編集"
  },
  "oncall": {
    "intro": "$t(translation:leaf.cur)には人ではなく当番表を指定します。毎週月曜 00:00（当番表のタイムゾーン）に次の人に交代します。",
    "new": "当番表を追加",
    "none": "当番表はまだありません",
    "none_body": "当番表がない場合、緊急インシデントは$t(translation:leaf.cur)のオーナーと管理者に送られます。",
    "unavailable": "当番表を読み込めません",
    "name": "名前",
    "now_on": "いまの当番",
    "nobody_now": "当番なし → {{name}} に直接送信",
    "supervisor": "当番責任者",
    "supervisor_hint": "15 分間誰も〔対応する〕を押さないときに送られます。当番がいない時間帯も直接送られます。",
    "used_by": "使用中",
    "homes_n": "{{n}} か所の$t(translation:leaf.cur)",
    "edit_title": "当番表を編集",
    "not_found": "当番表が見つかりません",
    "back": "当番表に戻る",
    "tz": "タイムゾーン",
    "rotation_start": "ローテーション開始日",
    "rotation_start_hint": "この日を含む週はリストの最初の人が当番です。",
    "slot_title": "時間帯とローテーション",
    "slot_name": "時間帯の名前",
    "slot_default": "終日",
    "time": "時刻",
    "start": "開始",
    "end": "終了",
    "time_hint": "開始と終了が同じ場合は終日、終了が開始より前の場合は日をまたぎます。",
    "days": "曜日",
    "gap": "ほかの時間は当番がいません：緊急インシデントは当番責任者 {{name}} に直接送られます（顧客は起こしません）。",
    "rotation": "週替わりのローテーション",
    "rotation_empty": "まだ誰もいません。少なくとも 1 人追加してください。",
    "this_week": "今週",
    "next_week": "来週",
    "up": "{{name}} を前に移動",
    "down": "{{name}} を後ろに移動",
    "remove": "{{name}} をローテーションから外す",
    "remove_short": "外す",
    "add_person": "ローテーションに加える人",
    "add": "追加",
    "pick": "メンバーを選ぶ",
    "summary": "今週（{{slot}}）：{{now}} · 責任者 {{sup}} · 来週：{{next}}",
    "summary_empty": "リストが空です：この時間帯の緊急インシデントは当番責任者に直接送られます。",
    "save_note": "保存時にもう一度本人確認をします。この当番表を使う$t(translation:leaf.cur)の組織に通知されます。",
    "save": "当番表を保存",
    "err_name": "名前を入力してください",
    "err_supervisor": "当番責任者を選んでください",
    "err_days": "少なくとも 1 日選んでください",
    "err_time": "時刻は 時:分 の形式で入力してください",
    "err_rotation": "ローテーションには少なくとも 1 人必要です",
    "err_conflict": "この当番表は他の人が変更しました。再読み込みしてから変更してください。"
  },
  "day": {
    "1": "月",
    "2": "火",
    "3": "水",
    "4": "木",
    "5": "金",
    "6": "土",
    "7": "日"
  },
  "err": {
    "default": "エラーが発生しました（{{code}}）。",
    "NETWORK": "サービスに接続できません。ネットワークを確認して再試行してください。",
    "NO_SESSION": "ログインの有効期限が切れました。もう一度ログインしてください。",
    "UNAUTHORIZED": "ログインの有効期限が切れました。もう一度ログインしてください。",
    "FORBIDDEN": "この操作の権限がありません。",
    "NOT_FOUND": "見つかりません。削除されたか、アクセス権がない可能性があります。",
    "UNAVAILABLE": "サービスが一時的に利用できません。しばらくしてから再試行してください。",
    "RATE_LIMITED": "操作の回数が多すぎます。しばらくしてから再試行してください。",
    "REAUTH_REQUIRED": "先に本人確認をしてください。",
    "PASSKEY_REQUIRED": "この操作にはパスキーが必要です。先に「マイアカウント › セキュリティ」でパスキーを登録してください。",
    "KMGR_REGION_UNSUPPORTED": "この組織の地域では IT 監視を提供していません。",
    "KMGR_DPA_REQUIRED": "先に IT 監視データ処理契約に同意してください。",
    "INVALID_ARGUMENT": "データが正しくありません。確認して再試行してください。",
    "INVALID_TRANSITION": "このインシデントは現在の状態からそのように変更できません。",
    "INCIDENT_STATE_CONFLICT": "このインシデントは他の人が変更しました。",
    "CONFLICT": "他の人が変更しました。再読み込みしてから再試行してください。",
    "FEATURE_DISABLED": "この環境ではこの機能は有効になっていません。",
    "KMGR_STOPPED": "IT 監視は組織によって一時停止されています。",
    "HANDOVER_INCOMPLETE": "代行作成した組織の引き継ぎがまだ完了していません",
    "ORG_LIMIT": "組織数が上限に達しました"
  },
  "cause": {
    "service_stopped": "{{target}} の {{subject}} が停止",
    "host_offline": "{{target}} がオフライン",
    "other": "{{target}} で異常",
    "disk_full": "{{target}} の {{subject}} のディスク容量が残りわずか",
    "power_outage": "停電",
    "ups_output_off": "{{target}} の出力が停止",
    "ups_overload": "{{target}} が過負荷",
    "ups_battery": "{{target}} のバッテリーに対応が必要",
    "poe_budget": "{{target}} の PoE 給電がしきい値を超過",
    "poe_denied": "{{target}} が PoE 給電を拒否"
  },
  "home_reason": {
    "incidents": "進行中のインシデント {{n}} 件",
    "unreadable_since": "どのパソコンも応答しません · 最終報告 {{time}}",
    "unreadable_never": "まだパソコンから報告がありません",
    "unset": "まだチェックインしたパソコンはありません",
    "watching": "{{n}} 台のパソコンを監視中",
    "collector_offline": "コレクター {{name}} が {{n}} 分オフライン",
    "snmp_auth": "ネットワーク機器の SNMP 認証に失敗",
    "maintenance_by": "{{name}}が設定したメンテナンス"
  },
  "ev_text": {
    "opened": "インシデント発生：{{cause}}",
    "recurred": "同じ原因で再発し、このインシデントに統合",
    "recovered": "復旧",
    "auto_resolved": "復旧後 24 時間対応がなかったため、システムがクローズ",
    "notify_opened": "{{who}} にプッシュ通知",
    "notify_resolved": "{{who}} に復旧通知（サイレント）",
    "home_admins": "$t(translation:leaf.cur)のオーナーと管理者"
  },
  "dur": {
    "minutes": "{{n}} 分",
    "hours": "{{n}} 時間",
    "days": "{{n}} 日"
  },
  "global_stop": {
    "title": "Kinio がすべての自動対処とリモート支援を停止中（{{time}} から）",
    "scope_all": "すべての組織が対象です。監視・インシデント・通知は通常どおり。再開は Kinio が行い、ここに再開ボタンはありません。",
    "scope_org": "この組織が対象です。監視・インシデント・通知は通常どおり。再開は Kinio が行います。"
  },
  "host": {
    "online": "オンライン",
    "offline": "オフライン",
    "offline_for": "オフライン {{for}}",
    "shutdown": "シャットダウン済み · {{time}}",
    "sleep": "スリープ中",
    "away": "不在 · {{for}}",
    "updating": "更新中 · {{n}} 分",
    "suspended": "停止中（複製）",
    "revoked": "取り消し済み",
    "unknown": "不明",
    "unlicensed": "未ライセンス",
    "is_collector": "コレクター",
    "critical": "重要ホスト",
    "critical_hint": "オフラインまたは登録済みサービスの停止を緊急として扱います（3 分間の猶予あり）。",
    "local_paused": "ローカルで一時停止（{{by}} {{time}}）",
    "local_paused_bar": "このパソコンの利用者 {{by}} が {{time}} に自動対処とリモート支援を一時停止しました（この 1 台のみ）。監視は継続します。",
    "key_hw": "セキュリティチップ",
    "key_sw": "ハードウェア保護なし",
    "metric_cpu": "CPU",
    "metric_mem": "メモリ",
    "metric_disk": "ディスク",
    "disk_mount": "ディスク {{mount}}",
    "primary_user": "主な利用者 {{name}}",
    "not_found": "このパソコンが見つかりません",
    "not_found_body": "削除されたか、この$t(translation:leaf.cur)への権限がなくなった可能性があります。",
    "back_list": "ホスト一覧に戻る",
    "tabs": "ホストのタブ",
    "tab_overview": "概要",
    "tab_telemetry": "何を報告しているか",
    "this_pc": "このパソコン",
    "class_seat": "{{cls}}（ライセンス：{{cls}}）",
    "last_seen": "最終報告",
    "collector_scan": "スキャンできるサブネット",
    "collector_none": "サブネット未指定",
    "collector_error": "コレクターのエラー：{{code}}",
    "settings_title": "このホストの監視設定",
    "expected_offline": "予定オフライン時間帯",
    "expected_offline_hint": "この時間帯は連絡がなくてもインシデントを開かず、オフラインにも数えません。サーバーには既定の時間帯はありません。",
    "expected_offline_ws": "ワークステーションの既定：終業後のシャットダウンやスリープはオフライン扱いにせず、7 日以上オンラインにならない場合のみ「通常」として表示します。固定の時間帯も追加できます。",
    "expected_offline_none": "なし",
    "save_note": "このホストの設定変更は監査に記録されます。",
    "saved": "保存しました。",
    "primary_user_label": "主な利用者",
    "primary_user_hint": "検索と表示に使います（リモート支援の待機画面にもこの名前を表示）。組織メンバーを選ぶか、名前を入力してください。サインインアカウントは収集しません。",
    "primary_user_ph": "例：山田 太郎 · 経理部",
    "primary_user_member": "組織メンバー"
  },
  "hosts": {
    "tabs": "ホストのタブ",
    "tab_all": "すべて",
    "tab_all_n": "すべて（{{n}}）",
    "tab_enrolling": "チェックイン中",
    "tab_unlicensed": "未ライセンス",
    "tab_unlicensed_n": "未ライセンス（{{n}}）",
    "filter_state": "状態",
    "state_any": "状態：すべて",
    "state_online": "オンライン",
    "state_offline": "オフライン",
    "state_expected_offline": "予定オフライン",
    "state_suspended": "停止中",
    "state_revoked": "取り消し済み",
    "filter_class": "種別",
    "class_any": "種別：すべて",
    "only_issues": "異常のあるもの",
    "unavailable": "ホスト一覧を取得できません",
    "none": "まだチェックインしたパソコンはありません",
    "none_body": "展開トークンを作成し、パソコンに管理プログラムをインストールするとここに表示されます。",
    "none_filtered": "該当するパソコンはありません",
    "shown_all": "全 {{n}} 台を表示",
    "footnote": "数値は異常時のみ色が付きます。「シャットダウン / スリープ / 更新中 / 不在」は予定オフラインで、インシデントは開きません。",
    "col_name": "名前",
    "col_home": "$t(translation:leaf.cur)",
    "col_org_home": "組織 › $t(translation:leaf.cur)",
    "col_class": "種別",
    "col_state": "状態",
    "col_metrics": "CPU · メモリ · ディスク",
    "col_version": "バージョン",
    "col_key": "鍵の保護",
    "col_since": "チェックイン日時",
    "col_actions": "操作",
    "enrolling_none": "チェックイン中のトークンはありません",
    "enrolling_none_body": "有効な展開トークンは使い切ったか未作成です。新しく作成してインストール時に使ってください。",
    "unlicensed_none": "未ライセンスのパソコンはありません",
    "unlicensed_none_body": "ライセンス数は足りています。",
    "unlicensed_bar": "{{n}} 台が未ライセンス：",
    "unlicensed_body": "オンライン状態と基本情報のみ報告し、指標は保存せず、インシデントも開かず、リモート支援もできず、ローカルルールも停止します。ライセンスを使い切ると後からチェックインしたものが未ライセンスになり、監視中のものは外されません。",
    "unlicensed_need_admin": "ライセンスの再割り当てや追加購入は、組織のオーナーか組織管理者が行います。",
    "reason_released": "ライセンスが別のパソコンに再割り当てされました",
    "search": "名前または主な利用者で検索",
    "search_none": "「{{q}}」に一致するパソコンはありません"
  },
  "seat": {
    "server": "サーバー",
    "workstation": "ワークステーション",
    "summary_title": "ライセンス数",
    "available_n": "残り {{n}} 台",
    "all_used": "すべて使用中",
    "buy": "追加購入…",
    "need_billing": "ライセンスの購入には請求権限が必要です。オーナー（{{name}}）に依頼してください。",
    "owner_role": "オーナー",
    "reassign_hint": "ライセンス済みのパソコン（退職者のノートパソコンなど）をここのパソコンに再割り当てすることもできます。",
    "reassign_btn": "ライセンスを再割り当て…",
    "reassign_title": "{{host}} にライセンスを再割り当て",
    "reassign_body": "このパソコンに割り当てるシートを選びます。そのシートを持っていたパソコンは未ライセンスになります。",
    "pick": "シートを選ぶ",
    "option_assigned": "{{host}}（{{time}} から）",
    "option_free": "空きシート",
    "no_seats": "この種別のシートはありません。",
    "reassign_warn": "{{host}} は未ライセンスになります。",
    "reassign_ok": "再割り当て"
  },
  "net": {
    "title": "ネットワークとホスト",
    "hosts_n": "{{n}} 台のパソコン",
    "unavailable": "ホストとネットワークを取得できません。ほかの欄は通常どおりです。",
    "unreadable": "ネットワーク機器を取得できません",
    "unreadable_collector": "ネットワーク機器を取得できません（コレクター {{name}} が {{for}} オフライン）",
    "and_more": "、他 {{n}} 台",
    "unreadable_auth": "ネットワーク機器を取得できません（SNMP 認証失敗）",
    "unreadable_note": "スイッチ・AP は数値に含まれていません",
    "see_collectors": "コレクターを見る",
    "collector_unnamed": "コレクター",
    "row_network_down": "ネットワーク機器が応答なし（WAN / スイッチ / AP）",
    "row_servers_offline": "サーバーがオフライン",
    "row_collectors_offline": "コレクターがオフライン",
    "row_devices_offline": "デバイスがオフライン",
    "row_storage_faults": "レコーダーのストレージ異常",
    "row_recording_gaps": "録画に欠落のあるカメラ（24 時間）",
    "n_network_down": "{{n}} 台",
    "n_servers_offline": "{{n}} 台",
    "n_collectors_offline": "{{n}} 台",
    "n_devices_offline": "{{n}} 台",
    "n_storage_faults": "{{n}} 台",
    "n_recording_gaps": "{{n}} 台",
    "n": "{{n}}",
    "n_hosts": "{{n}} 台",
    "others_ok": "ほか {{n}} 項目は正常",
    "all_ok": "{{n}} 項目すべて正常",
    "hosts_line": "パソコン：{{online}} オンライン · {{expected}} 予定オフライン",
    "todo_title": "未完了の設定",
    "todo_note": "故障ではないため、$t(translation:leaf.cur)の状態には数えません",
    "todo_unlicensed": "未ライセンスのパソコン",
    "tabs": "ネットワークとアプリのタブ",
    "tab_devices": "ネットワーク機器",
    "tab_devices_n": "ネットワーク機器（{{n}}）",
    "tab_probes": "アプリプローブ",
    "tab_probes_n": "アプリプローブ（{{n}}）",
    "tab_collectors": "コレクター",
    "tab_collectors_n": "コレクター（{{n}}）",
    "no_homes": "この範囲に監視中の$t(translation:leaf.cur)はありません",
    "no_homes_body": "範囲を変えるか、先に IT 監視を有効にしてください。",
    "partial_failed": "{{n}} か所の$t(translation:leaf.cur)を取得できません。ほかは通常どおりです。",
    "col_name": "名前",
    "col_addr": "アドレス",
    "col_method": "取得方法",
    "col_ifs": "インターフェース",
    "col_poe": "PoE",
    "col_temp": "温度",
    "col_collector": "コレクター",
    "col_target": "対象",
    "col_kind": "種類",
    "col_last": "最終チェック",
    "col_scan": "担当サブネット",
    "col_applied": "設定の適用",
    "method_snmp": "SNMP 読み取り専用",
    "method_ping": "ping のみ",
    "ok_snmp": "取得可",
    "ok_snmp_n": "取得可 · {{n}} 個のインターフェース",
    "ok_ping": "応答あり",
    "ok_probe": "正常",
    "bad_snmp": "取得失敗（コード {{code}}）",
    "bad_ping": "応答なし",
    "bad_probe": "失敗（コード {{code}}）",
    "unassigned": "担当コレクターなし",
    "noresult": "結果待ち",
    "ifs_down": "{{n}}（{{down}} 個がダウン）",
    "ifs_n": "{{n}} 個のインターフェース",
    "devices_note": "検出した Kinio デバイスはここではなく「デバイス」ページに表示。インターフェース・PoE・温度はコレクターが読める場合のみ。",
    "devices_none": "ネットワーク機器はまだありません",
    "devices_none_body": "まずパソコンを 1 台コレクターに指定してサブネットを割り当て、そのあとスイッチ・ルーター・ファイアウォールを追加します。",
    "probes_none": "アプリプローブはまだありません",
    "probes_none_body": "HTTP / TCP / ファイル更新チェックのプローブでサービスの稼働を確認します。",
    "collectors_none": "コレクターはまだありません",
    "collectors_none_body": "コレクターは、管理プログラムを入れた$t(translation:leaf.cur)内のパソコンで、ネットワーク機器の読み取りとプローブを担当します。",
    "setup_collector": "コレクターを設定",
    "setup_probe": "プローブを追加",
    "applied_v": "v{{v}} 適用済み",
    "pending_v": "v{{v}} 適用待ち（現在 v{{cur}}）",
    "row_disks_full": "ディスク残りわずか",
    "n_disks_full": "{{n}} 台",
    "by_org_title": "組織別",
    "org_net_down": "ネットワーク機器が応答なし {{n}}",
    "org_unreadable": "ネットワーク機器を取得できません",
    "org_servers_offline": "サーバーがオフライン {{n}}",
    "org_disks_full": "ディスク残りわずか {{n}}",
    "org_collectors_offline": "コレクターがオフライン {{n}}",
    "orgs_others_ok": "ほか {{n}} 組織は正常",
    "orgs_more": "ほか {{n}} 組織に問題があります。ホスト画面で組織を絞り込んで確認",
    "row_ups_on_battery": "電源・UPS バッテリー運転中",
    "n_ups_on_battery": "{{n}} 台",
    "row_ups_unreadable": "電源・UPS 取得不可",
    "n_ups_unreadable": "{{n}} 台",
    "row_poe_over_warn": "PoE 給電が注意しきい値超過",
    "n_poe_over_warn": "{{n}} 台",
    "todo_ups_no_downstream": "下流が未登録の UPS",
    "n_ups": "{{n}} 台",
    "org_ups_on_battery": "UPS バッテリー運転中 {{n}}",
    "org_poe_over_warn": "PoE しきい値超過 {{n}}",
    "tab_ups": "UPS",
    "tab_ups_n": "UPS {{n}}"
  },
  "collector": {
    "intro": "コレクターは、この$t(translation:leaf.cur)にある管理プログラム入りのパソコンです。スイッチ・ルーター・ファイアウォールを読み（SNMP 読み取り専用または ping）、アプリプローブを実行します。認証情報はコレクターにだけ保存され、クラウドからは見えません。",
    "policy_scan": "組織ポリシーで許可されたサブネット：{{cidrs}}",
    "policy_none": "組織ポリシーでサブネットがまだ許可されていません。組織管理者が「組織設定 › IT 監視 › セキュリティポリシー」で設定してください。",
    "none": "コレクターはまだありません",
    "none_body": "オンラインのパソコンをコレクターに選びます。",
    "add_device": "ネットワーク機器を追加…",
    "need_collector": "ネットワーク機器を追加するには先にコレクターが必要です。",
    "kinio_note": "検出した Kinio デバイス（カメラ、Kinio Station）は「Kinio デバイス」と表示してデバイスページにリンクし、重複作成しません。",
    "title": "コレクター",
    "scan": "スキャンできるサブネット",
    "scan_hint": "1 行に 1 サブネット（例 10.20.0.0/16）。組織ポリシーで許可された範囲内で指定してください。",
    "saved": "保存しました。コレクターがオンラインになると適用されます。",
    "err_scan": "{{target}} は組織が許可したサブネットの範囲外です。",
    "save_scan": "サブネットを保存",
    "local_note": "コレクター側でも有効化が必要です（管理プログラムの設定）。無効のときはここにエラーが表示されます。",
    "pick": "コレクターにするパソコン",
    "make": "コレクターにする"
  },
  "probe": {
    "intro": "プローブはコレクターが定期的に確認します：HTTP（ステータスコード・キーワード・証明書期限）、TCP ポート、ファイル更新（ジョブが動いたか）。応答の内容は収集しません。",
    "add": "プローブを追加…",
    "add_title": "プローブを追加",
    "edit": "編集…",
    "edit_title": "プローブを編集",
    "kind_ping": "ping",
    "kind_snmp": "SNMP",
    "kind_http": "HTTP",
    "kind_tcp": "TCP ポート",
    "kind_file": "ファイル更新チェック",
    "host": "ホスト名またはアドレス",
    "port": "ポート",
    "scheme": "スキーム",
    "path": "パス",
    "keyword": "キーワード（任意）",
    "http_hint": "ステータス 200 とキーワードの照合、遅延の計測、証明書期限の確認のみ。リダイレクトは追いません。",
    "file": "ファイルパス",
    "file_hint": "コレクター上のこのファイル（ネットワークパス含む）の最終更新時刻だけを見ます。内容は読みません。",
    "credential": "認証情報の参照",
    "credential_hint": "SNMP にはコレクター上の既存の認証情報参照が必要です（管理者がコレクター側で設定。クラウドからは見えません）。",
    "interval": "チェック間隔",
    "every_s": "{{n}} 秒ごと",
    "collector_auto": "自動（サブネットで判定）",
    "err_target": "対象アドレスを入力してください",
    "err_port": "ポートは 1–65535 の範囲で入力してください",
    "err_path": "パスは / で始めてください",
    "err_file": "ファイルパスを入力してください",
    "err_collector_offline": "コレクターがオフラインのためテストできません。先にオンラインを確認してください。",
    "err_collector_disabled": "コレクター側で収集機能が有効になっていません。",
    "test": "接続テスト",
    "test_ok": "接続できます",
    "tls_days": "証明書は {{n}} 日後に期限切れ",
    "test_timeout": "応答なし（タイムアウト）",
    "test_unreachable": "到達できません",
    "test_auth_failed": "認証失敗：ユーザー名またはパスワードが違います",
    "test_credential_missing": "認証情報がありません",
    "test_tls_error": "証明書に問題があります",
    "test_dns": "名前解決に失敗",
    "test_unexpected": "予期しない応答",
    "test_not_allowed": "対象が許可範囲外",
    "test_collector_error": "コレクターのエラー",
    "test_failed": "失敗",
    "create": "作成",
    "delete": "削除…",
    "delete_title": "「{{name}}」を削除",
    "delete_body": "このプローブのチェックとインシデントも一緒に解除されます。",
    "none_body": "プローブを追加してサービスの稼働を確認します。"
  },
  "threshold": {
    "intro": "条件ごとの重要度と猶予時間（どれだけ続いたらインシデントを開くか）。変更はこの$t(translation:leaf.cur)だけに適用されます。猶予時間は既定より長くのみ設定できます。録画に影響する条件はオフにできません。",
    "col_condition": "条件",
    "col_severity": "重要度",
    "col_debounce": "猶予時間",
    "rule_home_unreachable": "$t(translation:leaf.cur)と通信できない",
    "rule_camera_not_recording": "カメラが録画していない",
    "rule_recorder_storage": "レコーダーのディスク故障または録画容量 0",
    "rule_critical_host": "重要ホストのオフラインまたはサービス停止",
    "rule_network_device": "スイッチ / ルーター / WAN が応答なし",
    "rule_server_offline": "一般サーバーのオフライン・サービス停止、コレクターのオフライン",
    "rule_disk_tls_probe": "ディスク容量不足、SMART 警告、TLS 期限、プローブ失敗",
    "rule_unreadable": "取得不可（コレクターや管理プログラムと通信できない）",
    "rule_enroll_failed": "新しいパソコンのチェックイン失敗",
    "rule_workstation_offline": "ワークステーションが期限を超えてオフライン",
    "changed": "変更済み",
    "immediate": "即時",
    "minutes": "{{n}} 分",
    "no_incident": "インシデントを開かない",
    "disk_pct": "ディスク使用率の上限（%）",
    "tls_days": "TLS 期限切れまでの日数",
    "ws_days": "ワークステーションを通常として表示するまでのオフライン日数",
    "err_disk": "ディスクのしきい値は 50〜99 の範囲で指定してください",
    "err_tls": "TLS の日数は 1〜90 の範囲で指定してください",
    "err_ws": "ワークステーションの日数は 7〜90 の範囲で指定してください",
    "reset": "既定に戻す",
    "save_note": "しきい値の変更は監査に記録されます。",
    "saved": "保存しました。",
    "updated": "{{name}} が {{time}} に変更"
  },
  "maint": {
    "title": "メンテナンス時間帯",
    "inactive": "現在メンテナンス中ではありません。",
    "set_by": "{{name}} が {{time}} に設定",
    "active_note": "メンテナンス中はインシデント・プッシュ通知・自動対処を行いません。録画に影響する場合の現場通知は送ります。終了後 5 分経っても異常な場合はインシデントを開きます。",
    "end": "メンテナンスを終了",
    "quick_label": "ワンタッチメンテナンス",
    "extend_label": "延長",
    "hours_n": "{{n}} 時間",
    "start": "{{n}} 時間メンテナンス中にする",
    "extend": "延長",
    "quick_note": "新規設定や延長にはもう一度本人確認が必要で、この$t(translation:leaf.cur)の組織のオーナーと管理者に通知されます。終了には不要です。",
    "schedule": "メンテナンスのスケジュール",
    "schedule_none": "スケジュールなし。",
    "save_note": "スケジュールの新規設定・変更は本人確認が必要で、顧客に通知されます。",
    "save_schedule": "スケジュールを保存",
    "saved": "保存しました。",
    "saved_notified": "保存し、{{n}} 人に通知しました。",
    "unchanged": "変更はありません。"
  },
  "biz": {
    "title": "営業時間",
    "intro": "営業時間外はカメラとワークステーションのオフラインを 1 段階下げます（通知は止めません）。状態の横に ☾ を表示します。",
    "all_day": "終日営業（時間帯未設定）。",
    "save_note": "本人確認は不要です。監査に記録されます。",
    "saved": "保存しました。"
  },
  "window": {
    "days": "曜日",
    "start": "開始",
    "end": "終了",
    "remove": "削除",
    "add": "時間帯を追加",
    "hint": "開始と終了が同じ場合は終日、終了が開始より前の場合は日をまたぎます。",
    "err_days": "各時間帯で少なくとも 1 日選んでください",
    "err_time": "時刻は 時:分 の形式で入力してください",
    "every_day": "毎日",
    "all_day": "終日"
  },
  "site": {
    "title": "現場情報",
    "intro": "インシデントページの最上部に表示されます。変更はすべて監査に記録されます。",
    "edit": "編集",
    "collapse": "折りたたむ",
    "expand": "展開",
    "customer": "顧客",
    "level_n": "サービスレベル {{level}}",
    "until": "{{date}} まで",
    "level_note": "サービスレベルは表示のみで、通知には影響しません。緊急インシデントは常に当番表に従って通知します。",
    "contact": "現場連絡先",
    "call": "電話をかける",
    "it_support": "IT サポート",
    "rack": "ラック",
    "access": "入館",
    "f_service_level": "サービスレベル",
    "f_contract_until": "契約満了日",
    "f_contact_role": "連絡先の立場",
    "f_contact_name": "現場連絡先",
    "f_contact_phone": "電話番号",
    "f_it_support": "IT サポート電話と時間",
    "f_rack_note": "ラックの説明",
    "f_access_note": "入館の説明",
    "h_service_level": "インシデントページに表示のみ。通知には影響しません。",
    "h_contact_phone": "インシデントページから直接発信できます。",
    "h_it_support": "従業員のヘルプ画面に表示されます。",
    "ph_role": "ビル夜間警備",
    "ph_it": "03-1234-5678 · 月〜金 9:00–18:00",
    "err_phone": "電話番号には数字、+、-、括弧のみ使えます。",
    "save_note": "「監視設定」権限を持つ人が変更できます。変更はすべて監査に記録されます。",
    "saved": "保存しました。",
    "preview": "プレビュー：インシデントページ"
  },
  "telemetry": {
    "intro": "「{{agent}}」は以下のパソコンのヘルス情報だけを {{org}} に報告します。画面・ファイル・入力は見ません。",
    "last_upload": "最終報告 {{time}}。",
    "item_cpu_mem_disk": "CPU / メモリ / ディスク",
    "desc_cpu_mem_disk": "使用率、ディスクごとの使用量と SMART 状態",
    "item_net_bytes": "ネットワーク通信量の合計",
    "desc_net_bytes": "インターフェースごとの送受信合計。接続先は収集しません",
    "item_uptime_power": "稼働時間 · 電源状態",
    "desc_uptime_power": "起動からの時間、シャットダウン / スリープ / 更新再起動",
    "item_services": "サービスの稼働状況",
    "desc_services": "管理プログラムが検出し登録したサービスの名前と状態のみ",
    "item_os_update": "システム更新",
    "desc_os_update": "保留中の更新があるか",
    "item_event_log": "システムイベントログ",
    "desc_event_log": "ルールに一致した断片のみ送信。ユーザー名・メール・IP はマスク。ログイン名とセキュリティイベントは既定で収集しません",
    "never_title": "常に収集しないもの",
    "never_cmdline": "プログラムのコマンドライン引数",
    "never_window_title": "ウィンドウタイトル",
    "never_files": "開いているファイル名",
    "never_connections": "個別のネットワーク接続先",
    "never_images": "カメラ映像・サムネイル・スナップショット",
    "local_page": "このパソコンが実際に送った値は、そのパソコンで「{{agent}}」›〔収集内容を見る〕を開いて確認します。"
  },
  "remote": {
    "screen_person": "画面の前の方",
    "your_org": "あなたの組織",
    "list_sep": "、",
    "dialog_title": "リモート支援 · {{host}}",
    "tabs": "リモート支援のタブ",
    "tab_requests": "支援リクエスト",
    "tab_requests_n": "支援リクエスト（{{n}}）",
    "tab_records": "履歴",
    "form_lead": "{{name}}のパソコンにあなたの名前と「{{org}}」が表示され、〔許可〕が押されるまで始まりません。実施中は相手の画面に赤い枠とフローティングバーが表示され、いつでも終了できます。",
    "not_admin": "{{name}}はこのパソコンの管理者ではありません。管理者パスワードを求める画面（ドライバーのインストールなど）はあなたには見えず、代わりに押すこともできません。管理者アカウントを持つ方の立ち会いが必要です。",
    "perms_title": "相手に許可してもらう権限",
    "perm": {
      "view": "表示",
      "control": "操作",
      "clipboard": "クリップボード",
      "file_transfer": "ファイル転送"
    },
    "perm_hint": {
      "view": "相手の画面を見る（常に含まれます）",
      "control": "マウスとキーボードで操作する",
      "clipboard": "テキストを相互にコピー＆ペーストする",
      "file_transfer": "相手にファイルを送る。相手も自分で選んだファイルを送れます"
    },
    "no_recording": "今回は録画しません。",
    "no_recording_short": "録画なし",
    "reason": "理由（履歴に残り、相手には表示されません）",
    "reason_ph": "例：プリンターがずっとオフライン表示になる",
    "reason_assist": "支援コード {{code}}",
    "reason_assist_note": "支援コード {{code}}：{{note}}",
    "form_note": "次にパスキーで本人確認を行い、このパソコンでリモートツールを開きます。",
    "start_btn": "パスキーで確認して開始",
    "passkey_canceled": "パスキーの確認がキャンセルされました。まだ開始していません。",
    "auth_waiting": "ブラウザの案内に従ってパスキーで本人確認してください…",
    "tool_first": "このパソコンでリモート支援を使うのは初めてですか？",
    "tool_first_body": "相手の画面は「リモートツール」のウィンドウに表示されます。先にダウンロードしてインストールしてください。インストール済みならそのまま開始できます。",
    "tool_missing": "リモートツールが開きませんか？",
    "tool_missing_body": "このパソコンにまだインストールされていない可能性があります。インストール後にこのページへ戻ると自動でもう一度開きます（2 分以内）。それを過ぎた場合はキャンセルしてやり直してください。",
    "dl": {
      "windows": "リモートツールをダウンロード（Windows）",
      "macos": "リモートツールをダウンロード（macOS）",
      "linux": "リモートツールをダウンロード（Linux）"
    },
    "dl_none": "この環境ではリモートツールのダウンロード先が設定されていません。システム管理者にお問い合わせください。",
    "relaunch": "リモートツールを開く",
    "tool_installed": "インストール済み",
    "tool_open": "リモートツールが開きました。相手が許可すると画面が表示されます。",
    "tool_opening": "リモートツールを開いています… 反応がなければ",
    "waiting": "{{name}}の許可を待っています（{{time}}）",
    "waiting_over": "{{name}}からまだ応答がありません。確認しています…",
    "waiting_body": "{{name}}のパソコンに許可ウィンドウが表示されています。押せるのは本人だけです。電話で〔許可〕を押すよう伝えてください。",
    "cancel_session": "今回の支援をキャンセル",
    "connected": "{{host}} に接続しました",
    "connected_body": "相手の画面はリモートツールのウィンドウに表示されています。{{name}}の画面には常に赤い枠とフローティングバーが表示され、いつでも終了や権限の取り消しができます。",
    "slow": "接続が遅め",
    "upgrade_waiting": "{{name}}が{{what}}を許可するのを待っています（{{time}}）",
    "upgrade_input_off": "待っている間、あなたのマウスとキーボードは一時停止します。",
    "extend_what": "{{n}} 分延長",
    "col_perms": "権限",
    "col_until": "終了予定",
    "until": "{{time}} に自動終了（残り {{n}} 分）",
    "col_recording": "録画",
    "tip_uac": "相手の画面にシステムの権限ウィンドウが出てもあなたには見えません。相手に押してもらってください。",
    "tip_cad": "Ctrl+Alt+Del は送れません（システムのセキュリティ画面）。",
    "add_title": "追加する権限",
    "add_note": "{{name}}のパソコンにもう一度許可ウィンドウが表示されます。許可されなければ今の権限のままです。先にパスキーで本人確認します。",
    "add_send": "パスキーで確認して送信",
    "add_btn": "権限を追加…",
    "extend_btn": "{{n}} 分延長",
    "end_btn": "支援を終了",
    "ended_title": "{{host}} のリモート支援は終了しました",
    "ended_by": {
      "operator_end": "あなたが今回の支援を終了しました。",
      "user_end": "{{name}}が終了を押しました。",
      "time_limit": "時間切れで自動終了しました。"
    },
    "col_duration": "所要時間",
    "col_files": "転送したファイル",
    "no_files": "ファイル転送なし",
    "note": "ひとことメモ（履歴に残ります）",
    "note_ph": "例：印刷キューをリセットして復旧",
    "external_ticket": "外部チケット（任意）",
    "external_ticket_ph": "例：SR-20481",
    "note_audit": "メモとチケットは今回の支援の履歴に残り、組織の管理者が見られます。",
    "note_saved": "履歴に保存しました。",
    "note_save_close": "履歴に保存して閉じる",
    "note_then_close": "メモを残して終了",
    "note_shown": "メモ：{{note}} · 外部チケット：{{ticket}}",
    "done": "完了",
    "done_no_note": "メモなしで閉じる",
    "close": "閉じる",
    "retry": "もう一度試す",
    "go_passkey": "パスキーを登録",
    "go_policy": "セキュリティポリシーへ",
    "go_seats": "ライセンスを再割り当て",
    "err_code": "エラーコード {{code}}",
    "dur_lt_min": "1 分未満",
    "dur_h_m": "{{h}} 時間 {{m}} 分",
    "out": {
      "denied": "{{name}}が今回の支援を拒否しました",
      "reported": "{{name}}が「支援を頼んでいない」と報告しました",
      "timeout": "{{name}}から応答がありません",
      "no_user": "このパソコンには誰もサインインしていません。立ち会い型の支援には画面の前の方の許可が必要です",
      "locked": "{{name}}の画面がロックされています。先にロックを解除してもらってください",
      "reported_recently": "このパソコンでは 24 時間以内に「支援を頼んでいない」が押されています",
      "region": "このパソコンは中国本土にあるため、リモート支援はできません",
      "allowance": "このパソコンの設定ではリモート支援が許可されていません",
      "org_policy": "組織のセキュリティポリシーでリモート支援がオフになっています",
      "paused": "リモート支援は一時停止中です",
      "global_stop": "Kinio がすべてのリモート支援を停止しています",
      "unsupported_desktop": "このパソコンのデスクトップはまだリモート支援に対応していません",
      "role": "このパソコンのリモート支援の権限がありません",
      "forbidden": "このパソコンのリモート支援の権限がありません",
      "busy": "このパソコンでは別のリモート支援が進行中です",
      "offline": "このパソコンはオフラインです",
      "unlicensed": "このパソコンは未ライセンスのため、リモート支援できません",
      "taken": "このリクエストはすでに他の人が対応しています",
      "assist_expired": "この支援リクエストは期限切れです",
      "need_passkey": "リモート支援にはパスキーが必要です",
      "receipt": "本人確認に失敗しました",
      "too_many": "同時に進行中のリモート支援が多すぎます",
      "no_answer": "このパソコンから応答がありません",
      "connect_failed": "{{name}}は許可しましたが、接続できませんでした",
      "connection_lost": "接続が切れ、支援は終了しました",
      "expired": "今回の開始手続きは期限切れです",
      "revoked": "リモート支援の権限が取り消され、支援は終了しました",
      "kill_switch": "組織がリモート支援を停止し、支援は終了しました",
      "error": "開始できませんでした",
      "unlock_timeout": "{{name}}が画面のロックを解除しませんでした"
    },
    "out_next": {
      "denied": "履歴にメモを残せます。必要なら先に電話で確認してから、もう一度開始してください。",
      "reported": "「{{org}}」の管理者に通知しました。今後 24 時間は、あなたからこのパソコンへの支援を開始できません。",
      "timeout": "60 秒以内に〔許可〕が押されないと拒否扱いになります。電話で準備してもらってからもう一度試してください。",
      "no_user": "サインイン後にシステムトレイの〔リモート支援をリクエスト〕を押してもらってください。「支援リクエスト」に表示されます。",
      "locked": "ロック解除後に〔もう一度試す〕を押してください。",
      "reported_recently": "この期間は相手自身がシステムトレイの〔リモート支援をリクエスト〕を押し、「支援リクエスト」から開始する必要があります。",
      "region": "中国本土のパソコンではリモート支援を提供していません。",
      "allowance": "組織のオーナーまたは管理者がこのパソコンの許可範囲を広げる必要があります。",
      "org_policy": "組織のオーナーまたは管理者が「組織設定 › IT 監視 › セキュリティポリシー」でオンにできます。",
      "paused": "このパソコンの利用者または組織が自動対処とリモート支援を一時停止しています。再開後に試してください。",
      "global_stop": "監視・インシデント・通知は通常どおりです。再開は Kinio が行います。",
      "unsupported_desktop": "Linux は今のところ X11 デスクトップのみ対応しています。",
      "role": "組織の管理者に「リモート支援（立ち会いあり）」の権限を依頼してください。",
      "forbidden": "組織の管理者に「リモート支援（立ち会いあり）」の権限を依頼してください。",
      "busy": "そちらが終わってから開始してください。自分のものなら「リモート支援 › 履歴」で〔支援に戻る〕を押してください。",
      "offline": "オンラインになったらもう一度試してください。",
      "unlicensed": "ホストの「未ライセンス」でライセンスを割り当て直してから開始してください。",
      "taken": "1 つのリクエストに対応できるのは 1 人だけです。",
      "assist_expired": "リクエストは 30 分で期限切れになります。システムトレイからもう一度リクエストしてもらってください。",
      "need_passkey": "リモート支援は毎回パスキーで本人確認します（認証コードは使えません）。「マイアカウント › セキュリティ」で登録してください。",
      "receipt": "確認がタイムアウトしたか、パソコンの時刻がずれている可能性があります。もう一度試してください。",
      "too_many": "1 人が同時に進められるのは 3 件までです。ほかを先に終了してください。",
      "no_answer": "ちょうど切断された可能性があります。少し待ってからもう一度試してください。",
      "connect_failed": "リモートツールが 60 秒以内に接続しませんでした。開いていることを確認してからもう一度試してください。",
      "connection_lost": "相手のパソコンが 30 秒以上切断されました。もう一度試せます。",
      "expired": "作成から 5 分以内に本人確認が完了しませんでした。もう一度試してください。",
      "revoked": "",
      "kill_switch": "",
      "error": "もう一度試してください。",
      "unlock_timeout": "ロック解除後に〔もう一度試す〕を押すか、システムトレイの〔リモート支援をリクエスト〕を押してもらってください。"
    },
    "state": {
      "requested": "準備中",
      "awaiting_consent": "相手の許可待ち",
      "active": "進行中",
      "upgrade_pending": "進行中（権限追加の許可待ち）"
    },
    "end": {
      "denied": "相手が拒否",
      "reported": "相手が「頼んでいない」と報告",
      "timeout": "相手から応答なし",
      "operator_end": "終了",
      "user_end": "相手が終了",
      "revoked": "権限取り消し",
      "time_limit": "時間切れ",
      "kill_switch": "組織が停止",
      "rejected": "開始できず（当時このパソコンはリモート支援を受けられない状態）",
      "expired": "本人確認が未完了",
      "connect_failed": "接続できず",
      "connection_lost": "接続切れ",
      "unknown": "終了"
    },
    "unreadable": "ホスト一覧を取得できません",
    "no_hosts": "この範囲にはまだパソコンがありません",
    "no_hosts_body": "パソコンがチェックインすると、ここから支援できます。",
    "forbidden": "リモート支援の権限がありません",
    "forbidden_body": "支援リクエストを見るには「リモート支援（立ち会いあり）」の権限が必要です。「履歴」タブではご自身が開始した支援を確認できます。組織の管理者にお問い合わせください。",
    "assist_partial": "{{n}} 組織の支援リクエストを取得できません",
    "assist_title": "{{who}} が支援をリクエスト",
    "assist_code": "支援コード {{code}}",
    "assist_age": "{{time}} に送信",
    "assist_left": "あと {{n}} 分で期限切れ",
    "assist_taken": "{{name}}が対応中",
    "assist_start": "支援を開始",
    "assist_note": "電話で支援コードを照合し、同じパソコンであることを確認してください。開始後も相手が〔許可〕を押す必要があります。",
    "assist_none": "今は支援リクエストがありません",
    "assist_none_body": "従業員がパソコンのシステムトレイで〔リモート支援をリクエスト〕を押すとここに表示され、権限のある人にも通知されます。",
    "other_member": "ほかのメンバー",
    "range_from": "開始日",
    "range_to": "終了日",
    "export_csv": "CSV をエクスポート",
    "csv": {
      "start": "開始",
      "end": "終了",
      "minutes": "所要時間（分）",
      "operator": "担当者",
      "org": "組織",
      "home": "$t(translation:leaf.cur)",
      "host": "ホスト",
      "permissions": "権限",
      "result": "結果",
      "reason": "理由",
      "note": "メモ",
      "external_ticket": "外部チケット"
    },
    "records_unreadable": "リモート支援の履歴を取得できません",
    "col_start": "開始",
    "col_host": "ホスト",
    "col_operator": "担当者",
    "col_result": "結果",
    "col_note": "メモ / 外部チケット",
    "resume": "支援に戻る",
    "resume_host": "リモート支援に戻る",
    "ticket_short": "チケット {{ticket}}",
    "records_note": "所要時間は相手が〔許可〕を押してから終了までです。リモート支援は録画しません。",
    "records_none": "この期間のリモート支援はありません",
    "records_none_body": "別の期間を選んでください。",
    "host_btn": "リモート支援",
    "block": {
      "unlicensed": "未ライセンスのパソコンはリモート支援できません",
      "inactive": "このパソコンは停止中です",
      "offline": "このパソコンはオフラインです",
      "region": "中国本土のため、リモート支援はできません",
      "allowance": "このパソコンの設定ではリモート支援が許可されていません",
      "local_paused": "利用者がこのパソコンでリモート支援を一時停止しています",
      "phone": "パソコンからリモート支援を開始してください"
    },
    "wait_unlock": "{{name}}の画面がロックされています",
    "wait_unlock_body": "ロックが解除されると許可ウィンドウが自動でもう一度表示されます。やり直す必要はありません（最長 {{time}} まで待ちます）。電話でロック解除をお願いできます。",
    "sent_to_console": "このパソコンには他に {{n}} 件のサインイン中のセッションがあります。許可ウィンドウは画面の前（コンソール）の{{name}}に送られました。",
    "records_access_partial": "一部の$t(translation:leaf.cur)はご自身が開始した履歴だけ表示されます（その$t(translation:leaf.cur)のリモート支援権限がなく、組織のオーナー・管理者でもないため）。",
    "records_access_own": "ご自身が開始した履歴だけ表示しています。この範囲のリモート支援権限がなく、組織のオーナー・管理者でもありません。"
  },
  "review": {
    "go": "確認待ちのパソコンを見る",
    "title": "確認待ち（{{n}}）",
    "intro": "ホスト名が予定リストにない、またはチェックイン済みのパソコンと同名のパソコンはここで止まります。承認するまで ID は発行されず、トークンの台数やシートも使いません。15 分ごとにチェックインを再送します。",
    "selected": "{{n}} 台を選択",
    "select_hint": "選択するとまとめて処理できます",
    "select_all": "確認待ちをすべて選択",
    "select_one": "{{host}} を選択",
    "reject_btn": "拒否…",
    "accept_btn": "承認…",
    "col_reason": "確認が必要な理由",
    "col_seen": "検出時刻",
    "col_actions": "処理",
    "no_hostname": "（ホスト名の報告なし）",
    "reason_not_listed": "予定リストにない",
    "reason_duplicate_name": "チェックイン済みのパソコンと同名",
    "first": "初回 {{time}}",
    "last": "最終 {{time}}",
    "inactive": "このトークンはもう使えないため、これらのパソコンは承認できません。追加するには新しいトークンを作成してください。",
    "none_pending": "確認待ちのパソコンはありません。",
    "done_title": "処理済み（{{n}}）",
    "state_pending": "確認待ち",
    "state_accepted": "承認済み",
    "state_rejected": "拒否済み",
    "state_expired": "トークン失効のため未処理",
    "accept_title": "{{n}} 台のパソコンを承認",
    "accept_body": "{{list}}：承認すると ID が発行され、このトークンの$t(translation:leaf.cur)に追加され、トークンの台数とシートを {{n}} 使います（空きシートがなければ未ライセンス）· 約 15 分以内にチェックインが完了します。承認の前に本人確認をもう一度行います。",
    "accept": "承認",
    "reject_title": "{{n}} 台のパソコンを拒否",
    "reject_body": "{{list}}：今後このトークンではチェックインできません（ホスト名を変えても同じ）。追加するにはトークンを再作成してください。",
    "reject": "拒否",
    "partial": "{{ok}} 台を処理しました。未処理：{{bad}}",
    "accepted_n": "{{n}} 台を承認しました。約 15 分以内にチェックインが完了します。",
    "rejected_n": "{{n}} 台を拒否しました。",
    "err_done": "処理済み、またはこのトークンのものではありません"
  },
  "tpl": {
    "intro": "しきい値、プローブ、自動対処ルール、通知、メンテナンス / 営業時間をテンプレートにまとめ、複数の$t(translation:leaf.cur)に一括で適用します。新しいバージョンは自動では配布されないため、もう一度適用してください。",
    "show_archived": "アーカイブ済みも表示",
    "new": "テンプレートを追加",
    "new_title": "監視テンプレートを追加",
    "empty_title": "監視テンプレートはまだありません",
    "empty_body": "テンプレートを作成し、「適用」で$t(translation:leaf.cur)を選んで差分を確認してから適用します。",
    "col_name": "名前",
    "col_items": "内容",
    "col_version": "バージョン",
    "col_updated": "最終更新",
    "col_started": "開始",
    "col_state": "状態",
    "col_result": "結果",
    "col_home": "$t(translation:leaf.cur)",
    "archived": "アーカイブ済み",
    "archived_note": "このテンプレートはアーカイブ済みです。再適用はできません。適用済みの$t(translation:leaf.cur)には引き続き適用元のテンプレートが表示されます。",
    "new_hosts_note": "あとから追加したパソコンにはテンプレートのプローブとルールが自動では追加されません。もう一度適用してください。",
    "unavailable": "監視テンプレートを読み込めません",
    "applied_homes": "{{n}} か所の$t(translation:leaf.cur)に適用済み",
    "tabs": "テンプレートのタブ",
    "tab_content": "内容",
    "tab_apply": "適用",
    "tab_jobs": "適用履歴",
    "item_severity_overrides": "しきい値と重要度",
    "item_maintenance": "メンテナンス時間帯",
    "item_business_hours": "営業時間",
    "item_notify": "通知",
    "item_probes": "プローブ",
    "item_auto_rules": "自動対処ルール",
    "item_hint_severity_overrides": "チェックすると、すべての条件と数値をテンプレートで管理します（変更しないものは既定値）。",
    "item_hint_maintenance": "毎週繰り返すメンテナンス時間帯。単発のメンテナンスはテンプレートに含めません。",
    "item_hint_business_hours": "営業時間外は、カメラとワークステーションのオフラインの重要度を 1 段階下げます。",
    "item_hint_notify": "当番表のみ。顧客の連絡先は顧客のもので、テンプレートでは変更しません。",
    "item_hint_probes": "「対象の種類」で指定し、適用時に各$t(translation:leaf.cur)の既存のホスト、ネットワーク機器、コレクターに対応付けます。固定 IP は書けません。",
    "item_hint_auto_rules": "他の組織の$t(translation:leaf.cur)に適用した場合、顧客のオーナー / 管理者がパスキーで署名するまでルールは有効になりません。",
    "item_off": "テンプレートはこの項目を管理しません（$t(translation:leaf.cur)の設定のまま）。",
    "name": "名前",
    "description": "説明（任意）",
    "not_included": "テンプレートには認証情報、展開トークン、許可範囲ポリシー、顧客の連絡先は含まれません。",
    "pick_schedule": "当番表を選択",
    "notify_hint": "この組織の当番表である必要があります。顧客の$t(translation:leaf.cur)に適用すると、インシデントはこの当番表の当番に送られます。",
    "probe_name": "名前",
    "key": "キー",
    "probe_match": "対象",
    "probe_kind": "チェック",
    "match_servers": "サーバー",
    "match_critical": "重要ホスト",
    "match_workstations": "ワークステーション",
    "match_all_hosts": "すべてのホスト",
    "match_network_devices": "すべてのネットワーク機器（SNMP あり）",
    "match_collector_self": "コレクター自身",
    "kind_ping": "Ping",
    "kind_tcp": "TCP ポート",
    "kind_http": "HTTP(S)",
    "kind_file": "ファイル更新チェック",
    "port": "ポート",
    "http_path": "パス",
    "file_path": "ファイルパス",
    "interval": "チェック間隔",
    "seconds": "{{n}} 秒",
    "add_probe": "プローブを追加",
    "probe_note": "キーはテンプレート内の固定の識別子です。バージョンが変わっても同じキーは同じプローブとして扱います。",
    "rule_service": "サービス名",
    "rule_hosts": "ホスト",
    "rule_checks": "連続失敗回数",
    "add_rule": "ルールを追加",
    "rule_note": "停止したサービスを 1 回自動で再起動します。3 台を超えて該当する$t(translation:leaf.cur)では作成しません（人が対応）。",
    "err_name": "名前を入力してください",
    "err_empty": "1 項目以上必要です",
    "err_maint_empty": "メンテナンス時間帯を 1 つ以上追加してください",
    "err_schedule": "当番表を選択してください",
    "err_key": "キーには英小文字、数字、_、- のみ使えます",
    "err_key_dup": "キーが重複しています",
    "err_port": "TCP にはポートが必要です",
    "err_http_path": "HTTP パスは / で始めてください",
    "err_file": "ファイル更新チェックはコレクター自身のファイルのみ対象です。パスを入力してください",
    "err_service": "サービス名を入力してください",
    "save": "保存",
    "create": "テンプレートを作成",
    "save_note": "内容を変えると新しいバージョンになります。適用済みの$t(translation:leaf.cur)は自動では更新されません。",
    "saved": "保存しました。",
    "saved_version": "v{{v}} として保存しました。$t(translation:leaf.cur)への適用は「適用」から行います。",
    "conflict": "他の人がこのテンプレートを変更しました。再読み込みしてからやり直してください。",
    "archive": "アーカイブ",
    "archive_confirm": "アーカイブすると再適用できません。適用済みの$t(translation:leaf.cur)には影響しません。アーカイブしますか？",
    "pick_intro": "v{{v}} を適用する$t(translation:leaf.cur)を選択します（各$t(translation:leaf.cur)の設定権限が必要、委任経由も可）。次に差分を確認します。",
    "pick_filter": "$t(translation:leaf.cur)を検索",
    "pick_all": "すべて選択（{{n}}）",
    "pick_none": "クリア",
    "picked": "{{n}} か所の$t(translation:leaf.cur)を選択中",
    "preview_note": "プレビューでは設定は変わりません。200 か所の$t(translation:leaf.cur)ずつ処理します。",
    "preview": "差分をプレビュー（{{n}}）",
    "diff_summary": "{{homes}} か所の$t(translation:leaf.cur)で {{changes}} 項目が変わります。関係する顧客組織は {{orgs}} 組織で、適用後にそれぞれ 1 件通知されます。",
    "show_same": "変わらない項目も表示",
    "pending_rules": "{{n}} 件の自動対処ルールは「{{org}}」のパスキー署名待ちになり、署名までは実行されません。",
    "n_homes": "{{n}} か所の$t(translation:leaf.cur)",
    "n_changes": "{{n}} 項目が変更",
    "customer_field": "顧客の設定（{{v}}）。テンプレートでは変更しません",
    "skip_no_target": "この$t(translation:leaf.cur)に該当する対象がないため作成しません",
    "skip_too_many_targets": "3 台を超えて該当するため自動では作成しません（人が対応）",
    "ov_by": "{{org}}が変更（{{name}} {{date}}）",
    "fate_keep": "既定で保持",
    "fate_overwrite": "上書きされます",
    "overwrite_anyway": "それでも上書き",
    "pending_rule_row": "適用後に顧客の署名待ち",
    "skipped_title": "{{n}} か所の$t(translation:leaf.cur)をスキップ",
    "reason_no_permission": "この$t(translation:leaf.cur)の設定権限がありません",
    "reason_not_enabled": "この$t(translation:leaf.cur)では IT 監視が有効になっていません",
    "reason_no_target": "テンプレートのプローブとルールがこの$t(translation:leaf.cur)のどの対象にも該当しません",
    "reason_cancelled": "中断したため適用されていません",
    "reason_error": "一時的に適用できません（3 回再試行済み）",
    "reason_feature_disabled": "この環境では自動対処が有効になっていません",
    "reason_rule": "自動対処ルールを書き込めません（{{detail}}）",
    "back_pick": "$t(translation:leaf.cur)を選び直す",
    "apply_note": "適用すると顧客の$t(translation:leaf.cur)の設定が変わるため、本人確認が必要です。",
    "apply": "{{n}} か所の$t(translation:leaf.cur)に適用",
    "apply_confirm": "{{n}} か所の$t(translation:leaf.cur)に適用しますか？ 顧客組織 {{orgs}} 組織に通知されます。顧客が変更した項目は上のチェックに従います。",
    "apply_ok": "適用する",
    "preview_expired": "プレビューの有効期限（10 分）が切れました。もう一度プレビューしてください。",
    "jobs_empty": "まだ適用していません",
    "job_queued": "待機中",
    "job_running": "適用中",
    "job_done": "完了",
    "job_cancelled": "中断",
    "job_counts": "適用 {{applied}}、スキップ {{skipped}}、失敗 {{failed}}（全 {{total}}）",
    "job_progress": "{{done}} / {{total}}",
    "cancelling": "中断中：処理中の 1 か所が終わると止まります",
    "notified": "顧客組織 {{n}} 組織に通知済み",
    "cancel": "中断",
    "retry": "失敗した {{n}} か所の$t(translation:leaf.cur)を再試行",
    "result_pending": "待機中",
    "result_applied": "適用済み",
    "result_skipped": "スキップ",
    "result_failed": "失敗",
    "home_result": "{{changed}} 項目を変更、{{kept}} 項目を保持",
    "home_pending": "{{n}} 件のルールが顧客の署名待ち",
    "changed_since_preview": "プレビュー後に顧客が変更したため、適用時に再計算しました",
    "num_disk_pct": "ディスク使用率の上限",
    "num_tls_days": "TLS 期限の日数",
    "num_workstation_offline_days": "ワークステーションのオフライン日数",
    "key_schedule": "当番表",
    "key_customer_contact": "顧客の連絡先",
    "v_none": "なし",
    "v_owner_default": "$t(translation:leaf.cur)のオーナー（既定）",
    "v_days": "{{n}} 日",
    "v_collector_local": "コレクター自身",
    "v_probes": "{{n}} 件（{{targets}}）",
    "v_rule": "{{service}} 停止時に再起動 · 連続 {{checks}} 回 · {{n}} 台",
    "home_using": "「{{org}}」の監視テンプレート「{{name}}」v{{v}} を使用中",
    "home_overrides": "{{n}} 項目をここで変更",
    "home_archived": "「{{name}}」はアーカイブ済み",
    "home_newer": "「{{name}}」に新しいバージョン v{{v}} があります",
    "show_diff": "差分を見る",
    "hide_diff": "閉じる",
    "apply_to_others": "ほかの$t(translation:leaf.cur)に適用…",
    "from_home_name": "{{home}}の設定",
    "from_home_title": "「{{home}}」の現在の設定からテンプレートを作成",
    "from_home_note": "「{{home}}」の現在のしきい値と重要度、メンテナンス時間帯、営業時間、通知の当番表を入れました。プローブと自動対処はこの$t(translation:leaf.cur)自身の対象なので、必要なら下で対象の種類を指定して追加してください。保存後、適用する$t(translation:leaf.cur)を選べます。",
    "from_home_skip_notify": "通知用の当番表はこの組織のものではないため入れていません。",
    "from_home_failed": "この$t(translation:leaf.cur)の現在の設定を取得できません。管理する項目を選んでください。",
    "pick_from_home": "設定元「{{home}}」は一覧にありません。",
    "item_power": "電力アラート（PoE しきい値）",
    "power_warn": "注意",
    "power_high": "異常",
    "power_hint": "Station / スイッチ定格に対する PoE 割当・使用の割合（50〜100%）。適用すると各$t(translation:leaf.cur)の電力設定に書き込まれ、「テンプレートで管理」と表示されます。",
    "power_err": "しきい値は 50〜100 の範囲で、注意は異常以下にしてください",
    "val_power": "PoE 注意 {{warn}}%・異常 {{high}}%",
    "item_hint_power": "Station / スイッチ定格に対する PoE 割当・使用の割合（50〜100%）。適用すると各$t(translation:leaf.cur)の電力設定に書き込まれ、「テンプレートで管理」と表示されます。"
  },
  "install": {
    "title": "インストールパラメーター",
    "tab_windows": "Windows",
    "tab_gpo": "GPO スタートアップスクリプト",
    "tab_intune": "Intune",
    "tab_linux": "Linux",
    "tab_rmm": "RMM",
    "note_windows": "管理者として実行します。サイレントインストール後に自動でチェックインします。",
    "note_gpo": "コンピューターの構成 › Windows の設定 › スクリプト › スタートアップ。スクリプトとインストーラーはドメインコンピューターアカウントだけが読める共有フォルダーに置いてください。ドメインユーザーが読めると、トークンを全ドメインユーザーに渡すのと同じです。Intune をおすすめします。",
    "note_intune": "Win32 アプリのインストールコマンドです。インストール動作は「システム」を選びます。トークンは Intune 管理者にしか見えません。",
    "note_linux": "パッケージをインストールした後に実行します。トークンは標準入力から読み、コマンドラインに残しません。",
    "note_rmm": "RMM ツールのインストール変数です（管理者だけが見られる機密欄に入れてください）。",
    "gpo_download": "GPO スタートアップスクリプトをダウンロード"
  },
  "built": {
    "new_title": "顧客の組織を代行作成",
    "new_body": "代行作成した組織ではあなたが一時的にオーナーになります。$t(translation:leaf.cur)、当番表、テンプレート、トークンを設定してから顧客を招待して引き継ぎます。あなた自身の最大 5 組織には数えません。「{{org}}」が代行作成して未引き継ぎの組織は最大 20 組織です。",
    "name": "顧客の組織名",
    "create": "顧客のために作成",
    "switched": "「{{name}}」に切り替えました",
    "limit": "未引き継ぎの代行作成組織は最大 {{n}} 組織です。先に顧客に引き継ぎを完了してもらってください。",
    "unavailable": "代行作成した顧客を読み込めません",
    "none": "引き継ぎ待ちの顧客はいません",
    "none_body": "引き継ぎが完了した組織はここに表示されません。以後の関係は委任で決まります。",
    "count": "引き継ぎ待ち {{n}} / {{max}}",
    "col_name": "組織",
    "col_builder": "作成者",
    "col_customer": "引き継ぐ顧客",
    "col_created": "作成日",
    "customer_owner": "{{name}}（オーナー移譲済み）",
    "customer_joined": "{{name}}（参加済み）",
    "customer_invited": "{{email}} を招待済み",
    "customer_none": "未招待"
  },
  "handover": {
    "title": "引き継ぎ",
    "partner_fallback": "設置業者",
    "builder_fallback": "作成者",
    "customer_fallback": "引き継ぐ顧客",
    "not_built": "引き継ぐものはありません",
    "not_built_body": "代行作成された組織ではないか、引き継ぎが完了しています。",
    "unavailable": "引き継ぎの進捗を読み込めません",
    "intro_customer": "「{{partner}}」があなたのために「{{org}}」を作成しました。次の順に引き継ぎを完了してください",
    "intro_builder": "顧客のために「{{org}}」を代行作成しています。次の順に顧客へ引き渡してください",
    "remaining": "残り {{n}} ステップ",
    "dpa_bar": "顧客がデータ処理契約に同意していないため、パソコンをインストールしてもまだ報告を始めません（15 分ごとに自動で再試行、再インストール不要）。",
    "dpa_builder": "データ処理契約は顧客が同意します。ほかのステップは先に進められます。顧客が同意するまで、パソコンは報告を始めません。",
    "empty_keyset": "現在この組織のパソコンの設定を緩められる人がいません。いずれかのパソコンでローカル管理者が確認するか、新しいトークンでインストールし直してください。",
    "invite_title": "顧客を招待",
    "invite_body": "顧客が同じブランドのアカウントで参加すると、このページで引き継げます。アカウントのない人には登録リンクが届きます。",
    "invite_email": "顧客のメールアドレス",
    "invite_btn": "顧客を招待",
    "invite_again": "このアドレスに送り直す",
    "invite_pending": "{{email}} を招待済み（{{until}} まで有効）",
    "invited": "{{email}} を招待しました",
    "step_owner": "オーナー権限を「{{customer}}」に移譲",
    "step_dpa": "データ処理契約に同意",
    "step_delegation": "「{{partner}}」に委任",
    "step_template": "監視テンプレート",
    "step_customer_key": "「{{customer}}」の鍵をパソコンの管理者リストに追加",
    "step_builder_key": "「{{builder}}」の鍵を削除",
    "step_builder_left": "「{{builder}}」が引き継ぎを完了して退出",
    "state_done": "完了",
    "state_skipped": "スキップ",
    "state_todo": "現在のステップ",
    "state_waiting": "前のステップ待ち",
    "why_owner": "移譲後、「{{builder}}」は退出するまで組織管理者になります。",
    "why_dpa": "同意できるのは顧客だけです。同意後にパソコンが報告を始めます。",
    "why_delegation": "おすすめの範囲は「閲覧 + 設定と単発の処置」、12 か月です。スキップすると引き継ぎ後に「{{partner}}」は閲覧も対応もできません。",
    "why_template": "代行作成中に適用したテンプレート：残すか、既定に戻します（テンプレートが追加したプローブと未実行のルールを削除）。",
    "why_customer_key": "追加すると、パソコンの設定を緩められるようになります。「{{builder}}」が自分の鍵で署名します。",
    "why_builder_key": "削除すると「{{builder}}」が作成したトークンは無効になり、以後は「{{partner}}」が委任経由で再作成します。",
    "why_builder_left": "退出すると代行作成の関係は終わり、以後は委任だけになります。",
    "wait_builder": "「{{builder}}」を待っています",
    "wait_customer": "「{{customer}}」を待っています",
    "owner_btn": "オーナー権限を「{{customer}}」に移譲",
    "owner_need_customer": "先に顧客を招待してください",
    "owner_confirm_title": "「{{org}}」のオーナー権限を「{{customer}}」に移譲",
    "owner_confirm_body": "移譲後、あなたは組織管理者になります。次に「{{customer}}」がデータ処理契約に同意します。",
    "dpa_btn": "契約を確認して同意",
    "deleg_btn": "「{{partner}}」に委任…",
    "skip_btn": "スキップ",
    "skip_title": "委任をスキップ",
    "skip_body": "スキップすると、引き継ぎ後に「{{partner}}」は閲覧も対応もできません。「外部組織」からいつでも委任できます。",
    "tpl_keep": "残す",
    "tpl_row": "{{home}}：{{name}} v{{v}}",
    "revert_btn": "既定に戻す",
    "revert_title": "既定に戻す",
    "revert_body": "{{n}} か所の$t(translation:leaf.cur)のテンプレート項目を外します。テンプレートが追加したプローブと未実行のルールは削除し、しきい値と通知は現在の値を残します。",
    "sign_btn": "『「{{customer}}」の公開鍵を追加』に署名",
    "no_candidate": "「{{customer}}」はまだ署名用パスキーを登録していません。先に登録してもらってください。",
    "request_body": "まず「管理者パスキー」で署名用パスキーを登録し、「{{builder}}」にパソコンの管理者リストへの追加を依頼してください。",
    "request_btn": "「{{builder}}」に鍵の追加を依頼",
    "request_sent_at": "{{time}} に「{{builder}}」へ通知しました",
    "register_key": "署名用パスキーを登録",
    "sign_sent": "「{{builder}}」に通知しました",
    "sign_wait": "通知したばかりです。{{time}} 以降にもう一度通知できます",
    "remove_btn": "自分の鍵を削除",
    "remove_confirm_title": "あなたの鍵を削除",
    "remove_confirm_body": "あなたが作成した {{n}} 個のトークンは無効になります。以後は「{{partner}}」が委任経由で再作成し、新しいトークンはあなたを経由しません。チェックイン済みのパソコンには影響しません。",
    "tokens_title": "「{{builder}}」が作成したトークン（{{n}} 個）は無効になります",
    "token_row": "{{name}} · {{until}} まで · 未チェックイン {{n}} 台",
    "tokens_note": "無効になった後は「{{partner}}」が委任経由で再作成し、新しいトークンはあなたを経由しません。トークンを誰かに渡す必要はありません。",
    "tokens_ack": "OK",
    "revoke_btn": "今すぐ取り消す",
    "revoke_title": "{{n}} 個のトークンを取り消す",
    "revoke_body": "未チェックインのパソコンは、「{{partner}}」がトークンを再作成してインストール設定を置き換えるまでチェックインに失敗します。",
    "leave_btn": "引き継ぎを完了して退出",
    "leave_title": "「{{org}}」から退出",
    "leave_body": "退出すると、「{{org}}」でのあなたの権限はすべて取り消され、作成した残りのトークンも取り消されます。以後「{{partner}}」は委任経由でのみ対応できます。",
    "incomplete_owner_not_transferred": "オーナー権限がまだ顧客に移譲されていません。",
    "incomplete_customer_key_missing": "「{{customer}}」の鍵がまだパソコンの管理者リストにありません。",
    "incomplete_builder_key_present": "あなたの鍵がまだパソコンの管理者リストにあります。先に削除してください。",
    "conflict_handover_invite_exists": "すでに引き継ぐ顧客を招待しています。変更するには招待を取り消すか、そのメンバーを外してください。",
    "conflict_not_built_org": "この組織は代行作成中の組織ではありません。",
    "conflict_already_added": "あなたの鍵はすでにリストにあります。",
    "conflict_no_candidate": "署名用パスキーがまだ登録されていません。「管理者パスキー」で登録してください。",
    "not_handover_customer": "代行作成した組織のオーナー権限は、引き継ぐ顧客にしか移譲できません。",
    "banner_customer": "「{{partner}}」があなたのためにこの組織を作成しました",
    "banner_builder": "顧客のために「{{org}}」を代行作成しています",
    "banner_steps": "。引き継ぎ完了まで残り {{n}} ステップ",
    "banner_continue": "続ける"
  },
  "market": {
    "title": "現在、お住まいの地域では提供していません",
    "agent_body": "現在の接続地域では、{{agent}}のダウンロードとインストールは提供していません。",
    "tool_body": "現在の接続地域では、リモートツールのダウンロードは提供していません。"
  },
  "power": {
    "phase_outage": "停電中（バッテリー運転）",
    "phase_waiting": "商用電源は復旧しました。まだ {{n}} 台が復帰していません",
    "phase_restored": "復旧",
    "runtime_big": "残り約 {{n}} 分",
    "runtime_unk": "残り時間は取得不可",
    "runout": "{{time}} ごろに切れる見込み",
    "battery_pct": "残量 {{pct}}%",
    "load_pct": "負荷 {{pct}}%",
    "chart_title": "バッテリー残量・{{time}} から",
    "chart_none": "直近 30 分の残量は取得不可",
    "show_numbers": "数値を見る",
    "col_time": "時間",
    "downstream_line": "この UPS の下流：{{n}} 台（オフライン {{off}} 台）",
    "downstream_line_ok": "この UPS の下流：{{n}} 台",
    "no_downstream": "この UPS の下流にどのデバイスがあるか不明",
    "no_downstream_rec": "録画：録画デバイスが UPS の下流にあるか不明",
    "register": "下流を登録",
    "offline_title": "未復帰のデバイス",
    "skip": "これは待たない",
    "skip_aria": "これは待たない：{{name}}",
    "skip_done": "{{name}} を待たない設定にしました",
    "escalate_note": "復電から 30 分経っても未復帰のデバイスがあれば、当番表に従ってエスカレーションします",
    "events_title": "バッテリー切替の記録",
    "event_line": "{{from}}–{{to}}（{{min}} 分）",
    "event_ongoing": "{{from}} からバッテリー運転中",
    "escalated": "エスカレーション済み",
    "live_15": "UPS 残り 15 分未満",
    "live_5": "UPS 残り 5 分未満",
    "impact_title": "停電の影響",
    "row_line": "UPS 残り約 {{n}} 分（負荷 {{load}}%）",
    "row_line_noload": "UPS 残り約 {{n}} 分",
    "row_line_unk": "UPS 残り時間は取得不可",
    "col_name": "名前",
    "col_state": "状態",
    "col_battery": "残量",
    "col_runtime": "残り時間",
    "col_load": "負荷",
    "col_downstream": "下流",
    "st_normal": "商用電源",
    "st_battery": "バッテリー運転 {{n}} 分",
    "st_bypass": "バイパス",
    "st_none": "出力停止",
    "st_other": "その他",
    "st_selftest": "セルフテスト中",
    "st_unreadable": "取得不可（最終 {{time}}）",
    "val_unk": "取得不可",
    "minutes": "{{n}} 分",
    "downstream_n": "{{n}} 台",
    "downstream_none": "未登録",
    "todo_hint": "この UPS の下流が未登録です。停電時は各デバイスが個別にインシデントを起票します",
    "empty": "この範囲に UPS はまだありません。コレクターが SNMP（UPS-MIB / APC）で読み取った UPS は自動で表示されます。",
    "load_err": "UPS を取得できません",
    "detail_back": "UPS 一覧に戻る",
    "metrics": "計測値",
    "input_v": "入力電圧",
    "output_w": "出力電力",
    "temp": "バッテリー温度",
    "test": "セルフテスト",
    "test_pass": "合格",
    "test_warning": "警告あり",
    "test_error": "失敗",
    "test_aborted": "中止",
    "test_in_progress": "実行中",
    "test_none": "記録なし",
    "alarms": "UPS の報告",
    "alarms_none": "なし",
    "downstream_title": "この UPS の下流",
    "outage_open": "停電インシデント進行中",
    "see_incident": "インシデントを見る",
    "dlg_title": "「{{name}}」の下流デバイスを登録",
    "dlg_hint": "停電時、これらのデバイスのオフラインは 1 件の停電インシデントにまとめられ、個別にはインシデントを開きません。レコーダー（NVR / Station）を下流に登録すると、停電インシデントに録画への影響も表示できます。",
    "dlg_kinio": "Kinio デバイス",
    "dlg_hosts": "ホスト",
    "dlg_net": "ネットワーク機器",
    "dlg_search": "デバイスを検索",
    "dlg_all_group": "「{{group}}」をすべて選択",
    "dlg_save": "保存（{{n}} 台）",
    "dlg_saved": "{{n}} 台を登録しました",
    "dlg_max": "最大 200 台",
    "dlg_cancel": "キャンセル",
    "dlg_none": "この$t(translation:leaf.cur)に登録できるデバイスはありません",
    "no_configure": "この$t(translation:leaf.cur)の監視設定権限がありません",
    "alarm": {
      "battery_bad": "バッテリー交換が必要",
      "on_battery": "バッテリー運転中",
      "low_battery": "バッテリー残量低",
      "depleted_battery": "バッテリー切れ",
      "temp_bad": "温度異常",
      "input_bad": "入力電源異常",
      "output_bad": "出力異常",
      "output_overload": "出力過負荷",
      "on_bypass": "バイパス運転中",
      "bypass_bad": "バイパス異常",
      "output_off_as_requested": "指示により出力停止",
      "ups_off_as_requested": "指示により UPS 停止",
      "charger_failed": "充電器故障",
      "ups_output_off": "出力停止",
      "ups_system_off": "UPS 停止",
      "fan_failure": "ファン故障",
      "fuse_failure": "ヒューズ故障",
      "general_fault": "一般故障",
      "diagnostic_test_failed": "セルフテスト失敗",
      "communications_lost": "UPS との通信断",
      "awaiting_power": "電源復旧待ち",
      "shutdown_pending": "シャットダウン予定",
      "shutdown_imminent": "まもなくシャットダウン",
      "test_in_progress": "セルフテスト中"
    }
  }
}
